import React from 'react';
import { connect } from 'react-redux';

class PromoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section className={"promo-section ptb-100 " + (this.props.removeTopMargin ? '' : 'mt-5')}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-10">
                <div className="section-heading mb-5">
                  <span className="badge badge-primary badge-pill">
                    Frisbee App
                  </span>
                  <h5 className="h5 mt-3 mb-6">
                    Compra en las mejores marcas de Moda, Calzado, Cosméticos y Accesorios en 🇪🇨
                  </h5>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-sm-6 mb-lg-0">
                <div className="card single-promo-card single-promo-hover">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-target icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Descubre</h5>
                      <p className="text-muted mb-0">
                        Encuentra productos increíbles, recomendados solo para tí.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-face-smile icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Compra en Grupos</h5>
                      <p className="text-muted mb-0">
                        Para desbloquear el Precio Frisbee con descuentos desde el 25%, forma o únete a un Grupo de dos o más personas y ahorra en tus compras.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-money icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Ahorra</h5>
                      <p className="text-muted mb-0">
                        Comparte tus productos favoritos con tus amigos, familiares o conocidos por WhatsApp, Messenger o SMS. Invítalos a unirse a tu grupo de compra y ahorran todos juntos.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-thumb-up icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Relájate</h5>
                      <p className="text-muted mb-0">
                        Rastrea tus pedidos en tiempo real, recíbelos en tu casa en menos de 48 horas y vuelve a empezar.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state
}))(PromoSection);
